import React from 'react';
import {
  Checkbox as ChakraCheckbox,
  CheckboxProps as ChakraCheckboxProps,
  Text,
  SystemStyleObject,
} from '@chakra-ui/react';

export type CheckboxProps = ChakraCheckboxProps & {
  label?: React.ReactNode;
};

const baseSx: SystemStyleObject = {
  '& .chakra-checkbox__control': {
    bg: 'surface.control',
    borderColor: 'border.box',
    _checked: {
      bg: 'icon.green',
      borderColor: 'icon.green',
      _hover: {
        bg: 'icon.green',
        borderColor: 'icon.green',
      },
    },
  },
};

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  sx = {},
  fontSize,
  color,
  ...props
}) => {
  return (
    <ChakraCheckbox sx={{ ...baseSx, ...sx }} {...props}>
      {label &&
        (typeof label === 'string' ? (
          <Text
            fontWeight="bold"
            color={color || 'inherit'}
            fontSize={fontSize}>
            {label}
          </Text>
        ) : (
          label
        ))}
    </ChakraCheckbox>
  );
};
